import { h } from 'preact'; /** @jsx h */

import './StickyQRCTA.scss';

const StickyQRCTA = ({
    title = 'Bli støttemedlem',
    orientation = 'right',
    src = 'https://norskluftambulanse.no/wp-content/uploads/2023/12/juleaksjon-qr-kode.png',
    link = '#stott-oss',
    spaceY = false,
    target = '_self'
}) => {
    return (
        <div className={`cta-qr-wrapper cta-qr-wrapper-${orientation}`}>
            <div className={`sticky-qr-cta mid ${spaceY ? 'space-y' : ''}`}>
                <a className="sticky-qr-cta-content" href={link} target={target}>
                    <h3 className="sticky-qr-cta-title">{title}</h3>
                    <div className="qr-code">
                        <img
                            src={src}
                            width="135.8"
                            height="135.8"
                            alt="QR-kode til Stiftelsen Norsk Luftambulanse Vipps"
                            loading="lazy"
                        />
                    </div>
                    <div className="sticky-qr-cta-text">
                        <span className="sticky-qr-cta-caption">Vipps din julegave til</span>
                        <span className="sticky-qr-cta-vipps-nr">#2113</span>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default StickyQRCTA;
